import Icon from "@mui/material/Icon";
import Home from "home/components/Home";
import FactCheckIcon from "@mui/icons-material/FactCheck";

const routes = [
  {
    type: "collapse",
    name: "Home",
    key: "home",
    icon: <Icon fontSize="medium">home</Icon>,
    route: "/home",
    component: <Home />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Order Management",
    key: "OrderManagement",
    icon: <Icon fontSize="medium" >fact_check</Icon>,
    route: "/order-management",
    permissions: ["AccessOrderManagement"],
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Review Queue",
    key: "ReviewQueue",
    icon: <Icon fontSize="medium">rule</Icon>,
    route: "/review-queue",
    permissions: ["AccessOrderManagement"],
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Finance",
    key: "Finance",
    icon: <Icon fontSize="medium" >request_quote</Icon>,
    route: "/finance",
    permissions: ["AccessFinance"],
    collapse: [
      {
        name: "Invoicing",
        key: 'invoicing',
        route: "/finance/invoicing",

      },
      {
        name: "Ad Hoc Processes",
        key: 'adhoc-processes',
        route: "/finance/adhoc-processes",
      },
      {
        name: "BNSF Follow-Ups",
        key: "bnsf-followups",
        route: "/finance/bnsf-followups",
        permissions: ["AccessBnsfFollowUps"],
      },
    ],
  },
  // One Shifts menu, grouped by the legacy system each screen replaces. Both old apps are
  // still running, so which one a screen came from is the thing users need to orient by.
  {
    type: "collapse",
    name: "Shifts",
    key: "shifts",
    icon: <Icon fontSize="medium">schedule</Icon>,
    route: "/shifts",
    // AccessShifts is the only gate. The AccessOrderManagement fallback that carried this
    // through the transition is gone, so the permission has to be seeded in an environment
    // before the menu will appear there at all.
    permissions: ["AccessShifts"],
    // Flat list. The shift-* and yard-* screens stay adjacent so related work still reads
    // together without needing group headings.
    collapse: [
      {
        name: "Shift Update",
        key: 'update',
        route: "/shifts/dashboard/update",
      },
      // Shift Types and Cross-Reference are master data: Admin only, and hidden rather than
      // read-only so a field manager is not offered a screen they cannot use. Shift Update
      // deliberately stays visible to everyone -- managers read it to see what is still
      // outstanding for payroll, they just cannot change anything on it.
      {
        name: "Shift Types",
        key: 'types',
        route: "/shifts/dashboard/types",
        permissions: ["AccessShiftTypes"],
      },
      {
        name: "Cross-Reference",
        key: 'cross-reference',
        route: "/shifts/dashboard/cross-reference",
        permissions: ["AccessShiftCrossReference"],
      },
      {
        name: "Shift Log Sheet",
        key: 'log-sheet',
        route: "/shifts/dashboard/log-sheet",
      },
      {
        name: "Yard Schedule",
        key: 'schedule',
        route: "/shifts/logistrics/schedule",
      },
      {
        name: "Yard Daily",
        key: 'daily',
        route: "/shifts/logistrics/daily",
      },
      {
        name: "Yard Review",
        key: 'review',
        route: "/shifts/logistrics/review",
      },
    ],
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="medium">analytics</Icon>,
    route: "/reports",
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Employees",
    key: "employees",
    icon: <Icon fontSize="medium">peopleAltIcon</Icon>,
    route: "/employees",
    permissions: ["AccessEmployees"],
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Vehicles",
    key: "vehicles",
    icon: <Icon fontSize="medium">airport_shuttleIcon</Icon>,
    route: "/vehicles",
    permissions: ["AccessVehicles"],
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Clients",
    key: "clients",
    icon: <Icon fontSize="medium">recent_actorsIcon</Icon>,
    route: "/clients",
    permissions: ["AccessClients"],
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Hubs",
    key: "hubs",
    icon: <Icon fontSize="medium">hubIcon</Icon>,
    route: "/hubs",
    permissions: ["AccessHubs"],
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Points",
    key: "points",
    icon: <Icon fontSize="medium">location_searchingIcon</Icon>,
    route: "/points",
    permissions: ["AccessHubs", "AccessOrderManagement"],
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Forms",
    key: "forms",
    icon: <Icon fontSize="medium">description</Icon>,
    route: "/forms",
    permissions: ["AccessForms"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Map",
    key: "map",
    icon: <Icon fontSize="medium">mapIcon</Icon>,
    route: "/maps",
    collapse: [
      {
        name: "Current Locations",
        key: 'currentLocations',
        route: "/maps",

      }, {
        name: "Vehicle Activity History",
        key: 'vehicleActivityHistory',
        route: "/maps/history",

      }, {
        name: "Live Trips",
        key: 'liveTrips',
        route: "/maps/live-trips",

      },
    ]
  },
  {
    type: "collapse",
    name: "Admin",
    key: "admin",
    icon: <Icon fontSize="medium">admin_panel_settings</Icon>,
    permissions: ["AccessAdmin"],
    collapse: [
      {
        name: "Roles",
        key: 'roles',
        route: "/admin/roles",
      },
      {
        name: "Dispatch Queues",
        key: 'dispatch-queues',
        route: "/admin/dispatch-queues",
      },
      {
        name: "Suggested Events",
        key: 'suggested-events',
        route: "/admin/suggested-events",
      },
      {
        name: "Lookup Tables",
        key: 'lookup-tables',
        route: "/admin/lookup-tables",
      },
    ],
  },
];

export default routes;
